module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("CONTENTS")])]), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/006_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Acknowledgements"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/009_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1"
    }
  }, [_vm._v("PART ONE:")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2_RM"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1"
    }
  }, [_vm._v("ETHICS AT WORK")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/011_Chapter_2"
    }
  }, [_vm._v("1. Employing Parents Who Can’t Make a Living")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Meaning of Work Ethic")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. American Bosses: Sympathetic, Amoral Marketeers, and a Few Rule Breakers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO:")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2_RM"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TROUBLING CHILDREN")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Working for the Good of the Child")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. “Irresponsible” Parenting or Social Neglect?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Beyond Blame: Recognizing Unequal Choices")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE:")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2_RM"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SICKENING EFFECTS OF POVERTY")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/019_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. A Healer’s Dilemma")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/020_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Trying to Heal Economic Harms")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/021_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FOUR:")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2_RM"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/021_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAISING A MORAL UNDERGROUND")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/022_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Roots of Disobedience")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/023_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Raising a Moral Underground")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/024_BM1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Addendum: Research as Democracy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/025_Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee5fb14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0